import {
  SyberryTodayApiBacklogSectionKey,
  SyberryTodayApiPersonalBacklogCategory,
  type SyberryTodayApiBacklogSection,
  type SyberryTodayApiQueue,
} from './types';

export const SYBERRY_TODAY_API_SECTION_KEYS = [
  SyberryTodayApiBacklogSectionKey.TODAY,
  SyberryTodayApiBacklogSectionKey.LATER,
  SyberryTodayApiBacklogSectionKey.ONGOING_ACTIVITY,
  SyberryTodayApiBacklogSectionKey.PARENT_TASKS,
] as const;

export const SYBERRY_TODAY_POSTPONE_DURATION_MINUTES = 60;

export type SyberryTodayApiQueueMeta = Omit<SyberryTodayApiQueue, 'issues'>;

const SECTION_KEY_BY_CATEGORY: Record<SyberryTodayApiPersonalBacklogCategory, SyberryTodayApiBacklogSectionKey> = {
  [SyberryTodayApiPersonalBacklogCategory.INBOX]: SyberryTodayApiBacklogSectionKey.LATER,
  [SyberryTodayApiPersonalBacklogCategory.BLOCKED]: SyberryTodayApiBacklogSectionKey.LATER,
  [SyberryTodayApiPersonalBacklogCategory.TODAY]: SyberryTodayApiBacklogSectionKey.TODAY,
  [SyberryTodayApiPersonalBacklogCategory.ALL]: SyberryTodayApiBacklogSectionKey.LATER,
  [SyberryTodayApiPersonalBacklogCategory.ONGOING_ACTIVITY]: SyberryTodayApiBacklogSectionKey.ONGOING_ACTIVITY,
  [SyberryTodayApiPersonalBacklogCategory.PARENT_TASKS]: SyberryTodayApiBacklogSectionKey.PARENT_TASKS,
};

export const getSyberryTodayApiSectionKeyByCategory = (
  category: SyberryTodayApiPersonalBacklogCategory,
): SyberryTodayApiBacklogSectionKey => SECTION_KEY_BY_CATEGORY[category];

export const createEmptySyberryTodayApiSection = (): SyberryTodayApiBacklogSection => ({
  queues: [],
  issues: [],
});

export const getOrCreateSyberryTodayApiQueue = (
  section: SyberryTodayApiBacklogSection,
  queueMeta: SyberryTodayApiQueueMeta,
): SyberryTodayApiQueue => {
  const existingQueue = section.queues.find(queue => queue.id === queueMeta.id);

  if (existingQueue) return existingQueue;

  const queue = {
    ...queueMeta,
    issues: [],
  };

  section.queues.push(queue);

  return queue;
};
